/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type AdminTemplatesControllerListOrigin =
  (typeof AdminTemplatesControllerListOrigin)[keyof typeof AdminTemplatesControllerListOrigin];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTemplatesControllerListOrigin = {
  white_glove: 'white_glove',
  self_serve: 'self_serve',
  all: 'all',
} as const;
